export default __webpack_public_path__ + "static/media/add-thumb.b4e4ef18.svg";